import {
    COMPANIES_REQUEST,
    COMPANIES_SUCCESS,
    COMPANIES_FAIL,
    COMPANIES_MCPF_REQUEST,
    COMPANIES_MCPF_SUCCESS,
    COMPANIES_MCPF_FAIL,
    COMPANY_APPROVE_REQUEST,
    COMPANY_APPROVE_SUCCESS,
    COMPANY_APPROVE_FAIL,
    COMPANY_BLOCK_REQUEST,
    COMPANY_BLOCK_SUCCESS,
    COMPANY_BLOCK_FAIL,
} from '../constants/action-types';

const initialState = {
    data: [],
    companiesApproved: [],
    fetching: false,
    error: '',
}

export default function companies(state = initialState, action) {

    switch (action.type) {
        case COMPANIES_REQUEST:
        case COMPANIES_MCPF_REQUEST:
        case COMPANY_APPROVE_REQUEST:
        case COMPANY_BLOCK_REQUEST:
            return {
                ...state,
                fetching: true
            }
        case COMPANIES_SUCCESS:
            return {
                ...state,
                fetching: false,
                data: action.payload,
            }
        case COMPANIES_MCPF_SUCCESS:
            return {
                ...state,
                fetching: false,
                companiesApproved: action.payload,
            }
        case COMPANIES_FAIL:
        case COMPANIES_MCPF_FAIL:
        case COMPANY_APPROVE_FAIL:
        case COMPANY_BLOCK_FAIL:
            return {
                ...initialState,
                fetching: false,
                error: action.error || ''
            }
        default:
            return state;
  }

}



// WEBPACK FOOTER //
// ./source/reducers/companies.js